import ErrorPlaceholder from './ErrorPlaceholder';

export default ErrorPlaceholder;
